import { FC, useRef } from 'react'

import {
  Fixed,
  TransitionSlide,
  TransitionSlideProps,
  VStack,
} from '@revolut-internal/ui-kit'

import { UUID } from 'common/types'

import { Toast, ToastProps } from './Toast'

export type ToastTransition = Pick<TransitionSlideProps, 'in' | 'onExited'>

export type ToastWithTransition = ToastProps & {
  id: UUID
  transition: ToastTransition
}

export type ToastsStackProps = { toasts: ToastWithTransition[] }

const ToastListItem: FC<ToastWithTransition> = ({ transition, ...toastProps }) => {
  const nodeRef = useRef<HTMLDivElement>(null)

  return (
    <TransitionSlide
      in={transition.in}
      offsetY={-15}
      nodeRef={nodeRef}
      onExited={transition.onExited}
    >
      <Toast {...toastProps} nodeRef={nodeRef} />
    </TransitionSlide>
  )
}

const ToastList: FC<ToastsStackProps> = ({ toasts }) => {
  return (
    <>
      {toasts.map(toast => (
        <ToastListItem key={toast.id} {...toast} />
      ))}
    </>
  )
}

export const ToastsStack: FC<ToastsStackProps> = ({ toasts }) => {
  return (
    <Fixed bottom="s-24" zIndex={1} style={{ pointerEvents: 'none' }}>
      <VStack space="s-8" width="100vw" align="center">
        <ToastList toasts={toasts} />
      </VStack>
    </Fixed>
  )
}
